<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName + ' tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-tag"></i> {{ _('Pricings') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('showpricings')" class="tab-pane active" id="showpricings" v-if="isTabActive('showpricings')" key="showpricings" style="min-height: 500px">
            <div class="row">
              <div class="col-md-3 col-sm-4 filtercol">
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-sm-8 filtercol newbuttoncol">
                <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog('show')"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
              </div>
            </div>	
            <Datatable :url="showPricingsUrl" :search="search" :options="tableOptions" ref="datatableShowPricings" v-on:data="tableEvent" />
          </div>
          <div v-bind="tabPanel('zonepricings')" class="tab-pane active" id="zonepricings" v-if="isTabActive('zonepricings')" key="zonepricings" style="min-height: 500px">
            <div class="row">
              <div class="col-md-3 col-sm-4 filtercol">
                <div class="form-group">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-sm-8 filtercol newbuttoncol">
                <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog('zone')"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
              </div>
            </div>	
            <Datatable :url="zonePricingsUrl" :search="search" :options="tableOptions" ref="datatableZonePricings" v-on:data="tableEvent" />
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="modal-footer" v-if="isModal">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, PricingDetails } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      activeTab: 'showpricings',
      tableOptions: {
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editPricing(id, name)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'showpricings', label: this._('Show Pricings') },
        { id: 'zonepricings', label: this._('Zone Pricings') }
      ])
    },
    versionStr () {
      return '&locale=' + this.locale + '&version=' + this.version
    },
    showPricingsUrl () {
      return this.baseDomain + this.shopId + '/pricing.json?apikey=' + this.apiKey + this.versionStr
    },
    zonePricingsUrl () {
      return this.baseDomain + this.shopId + '/pricing.json?type=1&apikey=' + this.apiKey + this.versionStr
    }
  },
  methods: {
    createNewDialog (type) {
      this.showDialog({
        title: this._('Create new...'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: (data) => {
              this.createNew(type, data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async createNew (type, data) {
      let response
      const d = {
        name: data.name,
        type: type === 'zone' ? 1 : 0
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/pricing.json?apikey=' + this.apiKey + this.versionStr, d)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editPricing(response.data, data.name)
    },
    editPricing (id, name) {
      if (this.isModal) {
        this.showModal('pricingdetails', PricingDetails, {
          props: {
            baseDomain: this.baseDomain,
            shopId: this.shopId,
            apiKey: this.apiKey,
            component: {
              type: 'PricingDetails',
              initData: {
                pricingId: id,
                modal: true
              }
            },
            className: 'modal-content'
          },
          events: {},
          handlers: {},
          width: 1000
        })
      } else {
        this.EventBus.$emit('showDetailsColumn', {
          shopId: this.shopId,
          component: 'PricingDetails',
          title: this._('Pricing') + ' ' + id + ': ' + name,
          width: 6,
          data: {
            pricingId: id
          }
        })
      }
    },
    reload () {
      if (this.$refs.datatableShowPricings) {
        this.$refs.datatableShowPricings.reload()
      }
      if (this.$refs.datatableZonePricings) {
        this.$refs.datatableZonePricings.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['pricingUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>